// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M8.00391 7.99806H6V10.002H8.00391V7.99806Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M14 10V0.719238L2 3.71924V22L16 22V15H18V22H22V10H14ZM12 3.28079V20H4V5.28079L12 3.28079Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-10-filled')
export default class City10FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-10-filled',
    }
  }
}
